import type { TourStep } from './types';

export const categoriesSteps: TourStep[] = [
  {
    target: 'body',
    title: 'Добро пожаловать в раздел "Категории"',
    content: 'Категории определяют типы товаров в вашем каталоге. Каждая категория имеет свой набор характеристик: состав, размеры, сертификаты и др.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="categories-create-btn"]',
    title: 'Создание категории',
    content: 'Нажмите эту кнопку для создания новой категории товаров. Вы сможете задать все необходимые параметры.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="categories-list"]',
    title: 'Список категорий',
    content: 'Здесь отображаются все категории вашего каталога. Каждая категория имеет уникальный префикс и описание.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="categories-prefix"]',
    title: 'Префикс категории',
    content: 'Уникальный короткий код категории (например, "TOP", "LNP", "DVP"). Используется в артикулах товаров для идентификации.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="categories-description"]',
    title: 'Название категории',
    content: 'Полное название категории (например, "Топперы", "Леденец на палочке", "Декор для выпечки"). Отображается в интерфейсе при выборе категорий.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="categories-edit-btn"]',
    title: 'Редактирование',
    content: 'Нажмите для изменения параметров категории: префикса, названия, состава, размеров и сертификатов.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="categories-delete-btn"]',
    title: 'Удаление',
    content: 'Удалите категорию, если она больше не нужна. Внимание: нельзя удалить категорию с привязанными товарами!',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: 'body',
    title: 'Готово!',
    content: 'Теперь вы знаете, как управлять категориями товаров. Правильно настроенные категории упрощают работу с каталогом!',
    placement: 'center',
    disableBeacon: true,
  },
];
